import ShowcaseEvent from './showcase-event'

export default ShowcaseEvent
